<template>
    <div class="fixed bottom-0 ml-5 mb-3">
        Shoot me the answer in my DMs 📨
    </div>
</template>

<script>
export default {
    name: 'help'
}
</script>
